/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_HeadingInputs */

const en_visa_l1_heading = /** @type {(inputs: Visa_L1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Review L Cases`)
};

const pt_visa_l1_heading = /** @type {(inputs: Visa_L1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Revisamos Casos L`)
};

const es_visa_l1_heading = /** @type {(inputs: Visa_L1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Revisamos Casos L`)
};

/**
* | output |
* | --- |
* | "How We Review L Cases" |
*
* @param {Visa_L1_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_heading = /** @type {((inputs?: Visa_L1_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_heading(inputs)
	if (locale === "es") return es_visa_l1_heading(inputs)
	return en_visa_l1_heading(inputs)
});